import { useMutation, useQueryClient } from "@tanstack/react-query";
import { getUsersApiClient } from "@shared/apis/sidekick/api-factories";
import { buildGetUsersQueryKey } from "./useGetUsers";
import { buildGetUserQueryKey } from "./useGetUser";
import { toast } from "@shared/services/toast";

type Props = {
  onSuccess?: () => void;
};

type Params = {
  userId: string;
};

export const useDeleteUser = (props?: Props) => {
  const { onSuccess } = props || {};
  const api = getUsersApiClient();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: async ({ userId }: Params) => {
      const response = await api.userControllerDeleteUser({
        userId: userId,
      });

      queryClient.invalidateQueries({ queryKey: buildGetUsersQueryKey() });
      queryClient.invalidateQueries({
        queryKey: buildGetUserQueryKey(userId),
      });
      toast.success("User deleted successfully.");
      onSuccess?.();
      return response;
    },
    onError: (error, { userId }) => {
      console.error(`Failed to delete user with ID: ${userId}`, error);
      toast.error(`Failed to delete user with ID: ${userId}`);
    },
  });

  return mutation;
};
